export default __webpack_public_path__ + "static/media/reg-1.32742a45.jpeg";